import React, { forwardRef, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

interface FormFieldProps {
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    type?: string;
    id?: string;
    placeholder: string;
    autoComplete?: string;
    required?: boolean;
    error?: string;
    autoFocus?: boolean;
}

const FormField = forwardRef<HTMLInputElement, FormFieldProps>(
    ({ value, onChange, type = "text", id, placeholder, autoComplete = "off", required = false, error, autoFocus = true }, ref) => {
        const [hide, setHide] = useState(true);

        if (type === "password") {
            return (
                <div className="gs-auth-field-wrap">
                    <Input
                        ref={ref}
                        autoFocus={autoFocus}
                        value={value}
                        onChange={onChange}
                        type={hide ? "password" : "text"}
                        autoComplete={autoComplete}
                        required={required}
                        id={id}
                        placeholder={placeholder}
                        className="gs-auth-input-lg pr-10"
                    />
                    <button
                        type="button"
                        tabIndex={-1}
                        onClick={() => setHide(!hide)}
                        className="gs-auth-password-toggle"
                        aria-label={hide ? "Show password" : "Hide password"}
                    >
                        {hide ? (
                            <Eye id={`${id}-icon`} className="size-[1.125rem]" />
                        ) : (
                            <EyeOff id={`${id}-icon`} className="size-[1.125rem]" />
                        )}
                    </button>
                    {error && <p className="mt-1 text-xs text-destructive">{error}</p>}
                </div>
            );
        }

        return (
            <div>
                <Input
                    ref={ref}
                    autoFocus={autoFocus}
                    value={value}
                    onChange={onChange}
                    type={type}
                    autoComplete={autoComplete}
                    required={required}
                    id={id}
                    placeholder={placeholder}
                    className="h-11 text-sm"
                />
                {error && <p className="mt-1 text-xs text-destructive">{error}</p>}
            </div>
        );
    }
);

FormField.displayName = "FormField";

export default FormField;
